type Map = {
  [key: string]: string;
};
export const timeFrameMap: Map = {
  MINUTES: 'm',
  DAYS: 'D',
  WEEKS: 'W',
  MONTHS: 'M',
  QUARTERS: 'Q',
  YEARS: 'Y',
};
